import useAppStore from 'store/useAppStore';
import {
  arrowColors,
  generateArrowPath,
  generateArrowTriangle,
  generateNodePositions,
  svgConfig,
} from './utils';

// 生成連接箭頭
const RenderArrows = ({ sortDevices, sortStations }) => {
  const { nodeHeight } = svgConfig;
  const scripts = useAppStore((state) => state.scripts);
  const materialDevicePositions = generateNodePositions(sortDevices, 0);
  const stationPositions = generateNodePositions(sortStations, 1);
  return scripts
    .map((script, scriptIndex) => {
      // 檢查腳本是否完整
      if (
        !script['區段腳本名稱'] ||
        !script['起始工站'] ||
        !script['移動設備'] ||
        !script['目標工站']
      ) {
        return null;
      }
      // 找到對應的節點位置
      const startStation = stationPositions.find(
        (s) => s.id === script['起始工站'].id,
      );
      const moveDevice = materialDevicePositions.find(
        (d) => d.id === script['移動設備'].id,
      );
      const targetStation = stationPositions.find(
        (s) => s.id === script['目標工站'].id,
      );

      if (!startStation || !moveDevice || !targetStation) return null;

      // 為每個腳本分配不同的顏色
      const arrowColor = arrowColors[scriptIndex % arrowColors.length];

      // 計算節點中心位置
      const nodeWidth = 120; // 從 svgConfig 取得
      const centerOffset = nodeWidth / 2;
      
      // 使用更細緻的箭頭分散策略
      const totalScripts = scripts.length;
      const arrowSpacing = Math.min(20, nodeWidth / Math.max(totalScripts, 1)); // 動態間距
      const startOffset = -(totalScripts - 1) * arrowSpacing / 2; // 居中分佈
      const currentOffset = startOffset + scriptIndex * arrowSpacing;

      // 第一條箭頭：站台1 → 設備1
      const arrow1StartX = startStation.x + centerOffset + currentOffset;
      const arrow1StartY = startStation.y; // 站台膠囊上方
      const arrow1EndX = moveDevice.x + centerOffset + currentOffset;
      const arrow1EndY = moveDevice.y + nodeHeight; // 設備膠囊下方

      // 第二條箭頭：設備1 → 站台2
      const arrow2StartX = moveDevice.x + centerOffset + currentOffset;
      const arrow2StartY = moveDevice.y + nodeHeight; // 設備膠囊下方
      const arrow2EndX = targetStation.x + centerOffset + currentOffset;
      const arrow2EndY = targetStation.y; // 站台膠囊上方

      return (
        <g key={`arrow-${script.id}`}>
          {/* 第一條箭頭：站台1 → 設備1 */}
          <path
            d={generateArrowPath(
              arrow1StartX,
              arrow1StartY,
              arrow1EndX,
              arrow1EndY,
              0,
            )}
            stroke={arrowColor}
            strokeWidth="3"
            fill="none"
          />
          <path
            d={generateArrowTriangle(
              arrow1StartX,
              arrow1StartY,
              arrow1EndX,
              arrow1EndY,
              0,
            )}
            fill={arrowColor}
          />

          {/* 第二條箭頭：設備1 → 站台2 */}
          <path
            d={generateArrowPath(
              arrow2StartX,
              arrow2StartY,
              arrow2EndX,
              arrow2EndY,
              0,
            )}
            stroke={arrowColor}
            strokeWidth="3"
            fill="none"
          />
          <path
            d={generateArrowTriangle(
              arrow2StartX,
              arrow2StartY,
              arrow2EndX,
              arrow2EndY,
              0,
            )}
            fill={arrowColor}
          />
        </g>
      );
    })
    .filter(Boolean);
};

export default RenderArrows;
